import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { CustomFile } from '../../Types/file';
import { PaginatedResult } from '../../Types/pagination';
import { getIndexedFiles } from '../actions/indexActions';
import { RootState } from '../store';

interface IndexState {
  indexFiles: CustomFile[];
  totalFiles: number;
  loading: boolean;
}

const initialState: IndexState = {
  indexFiles: [],
  totalFiles: 0,
  loading: false,
};

const indexSlice = createSlice({
  name: 'indexes',
  initialState,
  reducers: {
    clearIndexFiles: (state) => {
      state.indexFiles = [];
      state.totalFiles = 0;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getIndexedFiles.pending, (state) => {
        state.loading = true;
      })
      .addCase(
        getIndexedFiles.fulfilled,
        (state, action: PayloadAction<PaginatedResult<CustomFile>>) => {
          state.indexFiles = action.payload.items;
          state.totalFiles = action.payload.total;
          state.loading = false;
        }
      );
  },
});

export const { clearIndexFiles } = indexSlice.actions;

export const selectIndexes = (state: RootState) => state.indexes;

export default indexSlice.reducer;
